import React from "react";

import { css, cx } from "@emotion/css";
import { useSearch, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import type { Theme } from "@/theme/CreateTheme.ts";
import { useIsDesktopScreen } from "@/theme/responsive.ts";
import { SearchBar } from "@/uiKit/atoms/inputs/SearchBar.tsx";

const SEARCH_BASIS_PX = 100;

export type PatientListSearchProps = {
  className?: string;
};

export const PatientListSearch: React.FC<PatientListSearchProps> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const searchParams = useSearch({
    from: "/_practitioner/patients/",
  });
  const searchTerm = searchParams.search ?? "";
  const isDesktopScreen = useIsDesktopScreen();

  return (
    <SearchBar
      value={searchTerm}
      id="search-in-patient-list"
      className={cx(styles.root, className)}
      autoFocus={isDesktopScreen}
      onChange={value => {
        navigate({
          to: ".",
          search: {
            menu: "all",
            search: value,
          },
        });
      }}
      placeholder={t("search.searchPatient")}
    />
  );
};

const makeStyles = (theme: Theme) => ({
  root: css({
    flex: `1 1 ${SEARCH_BASIS_PX}px`,
    maxWidth: theme.spacing(96),
    minWidth: `${SEARCH_BASIS_PX}px`,
    overflow: "clip",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
});
